<template>
    <div v-if="wizardStore.isContact" class="tw:space-y-5">
        <hr class="tw:border-zinc-200" />
        <div v-if="wizardStore.tw" class="tw:text-xs tw:text-zinc-500">
            {{ $t("Felter markert med stjerne (*) er obligatoriske.") }}
        </div>
        <small v-if="!wizardStore.tw">
            {{ $t("Felter markert med stjerne (*) er obligatoriske.") }}
        </small>
        <p class="tw:mb-2 tw:text-base tw:font-medium tw:text-zinc-800">
            {{ $t("Kontaktperson") }} / {{ $t("Betaler") }}
        </p>

        <div class="tw:space-y-4">
            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Ditt mobilnummer') + '*'"
                :name="'mobile'"
                :type="'tel'"
                :placeholder="$t('Mobilnummer')"
                :maxlength="10"
                :disabled="wizardStore.isLoadingContact"
                v-model="wizardStore.contact.mobile"
                :error="wizardStore.contact.errors.mobile"
            />

            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Ditt fødselsnummer') + '*'"
                :name="'fnr'"
                :type="'tel'"
                :placeholder="wizardStore.nnidPlaceholder"
                :disabled="wizardStore.isLoadingContact"
                v-model="wizardStore.contact.fnr"
                :error="wizardStore.contact.errors.fnr"
            />
        </div>

        <div v-if="wizardStore.showContactDetailFields" class="tw:space-y-4">
            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Fornavn') + '*'"
                :name="'first_name'"
                :placeholder="$t('Fornavn')"
                :disabled="!!(wizardStore.contact.lookupResponse && wizardStore.contact.lookupResponse.first_name)"
                v-model="wizardStore.contact.firstName"
                :required="true"
                :error="wizardStore.contact.errors.firstName"
            />

            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Etternavn') + '*'"
                :name="'last_name'"
                :placeholder="$t('Etternavn')"
                :disabled="!!(wizardStore.contact.lookupResponse && wizardStore.contact.lookupResponse.last_name)"
                v-model="wizardStore.contact.lastName"
                :required="true"
                :error="wizardStore.contact.errors.lastName"
            />

            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Adresse') + '*'"
                :name="'address'"
                :placeholder="$t('Adresse')"
                :disabled="!!(wizardStore.contact.lookupResponse && wizardStore.contact.lookupResponse.address)"
                v-model="wizardStore.contact.address"
                :required="true"
                :error="wizardStore.contact.errors.address"
            />

            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Postnummer') + '*'"
                :name="'postal_code'"
                :placeholder="$t('Postnummer')"
                :disabled="!!(wizardStore.contact.lookupResponse && wizardStore.contact.lookupResponse.postal_code)"
                v-model="wizardStore.contact.postalCode"
                :required="true"
                :error="wizardStore.contact.errors.postalCode"
            />

            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('Sted') + '*'"
                :name="'city'"
                :placeholder="$t('Sted')"
                :disabled="!!(wizardStore.contact.lookupResponse && wizardStore.contact.lookupResponse.city)"
                v-model="wizardStore.contact.city"
                :required="true"
                :error="wizardStore.contact.errors.city"
            />

            <FormTextInput
                :tw="wizardStore.tw"
                :label="$t('E-postadresse') + '*'"
                :name="'email'"
                :placeholder="$t('E-postadresse')"
                :disabled="!!(wizardStore.contact.lookupResponse && wizardStore.contact.lookupResponse.email)"
                v-model="wizardStore.contact.email"
                :required="true"
                :error="wizardStore.contact.errors.email"
            />
        </div>

        <div
            v-if="noContactLookupResponse"
            :class="{'btn btn-link': !wizardStore.tw, 'tw:text-sm tw:text-(--shop-primary) tw:underline tw:cursor-pointer': wizardStore.tw}"
            @click="wizardStore.toggleManuallyRegisterContact"
        >
            {{ wizardStore.toggleManuallyRegisteredContactLabel }}
        </div>
        <loadingSpinner :isLoading="wizardStore.isLoadingContact" :tw="wizardStore.tw" />
        <div
            v-if="wizardStore.contact.errors.lookup"
            class="tw:rounded-md tw:border tw:border-red-200 tw:bg-red-50 tw:p-3 tw:text-sm tw:text-red-700"
        >
            {{ wizardStore.contact.errors.lookup }}
        </div>
    </div>
</template>
<script setup>
import { useWizardStore } from "./wizardState";
import loadingSpinner from "./loadingSpinner.vue";
import { computed, watch } from "vue";
import FormTextInput from './FormTextInput.vue'

const wizardStore = useWizardStore();

const noContactLookupResponse = computed(() => {
    return !wizardStore.contact.lookupResponse || Object.keys(wizardStore.contact.lookupResponse).length === 0;
});

const validateAndLookup = () => {
    if (wizardStore.contact.errors && wizardStore.contact.errors.lookup) {
        delete wizardStore.contact.errors.lookup;
    }
    if (!wizardStore.contactHasValidFnrAndMobile()) {
        wizardStore.disableManuallyRegisterContact();
        return;
    }
    wizardStore.resetContactLookupResponse();
    wizardStore.validateAndLookupContact();
};

watch(
    () => wizardStore.contact.fnr,
    () => {
        validateAndLookup();
    }
);

watch(
    () => wizardStore.contact.mobile,
    () => {
        validateAndLookup();
    }
);
</script>
